<template>
<q-page class="main notifications">
  <div class="row justify-center">
    <q-card class="page-card col-xs-12 col-md-8">
      <q-card-section class="page-card__main-content">
        <h1 class="heading-2 q-mb-lg">Inrichtingselementencatalogus</h1>
        <form method="GET">
          <div class="row q-col-gutter-lg">
            <common-input
                class="col-12"
                label="Zoektermen"
                v-model="search.query"
                name="search"
            />
            <q-select
                label="Categorie filter"
                v-model="search.categories"
                :options="categoriesArray"
                class="col-12 col-sm-6 col-md-4"
                :dense="$isMobile"
                multiple
                outlined
                name="category[]"
                :display-value="categoriesDisplayValue"
            />
            <q-select
                label="Subcategorie filter"
                v-model="search.groups"
                :options="objectGroupsArray"
                class="col-12 col-sm-6 col-md-5"
                :dense="$isMobile"
                multiple
                outlined
                :display-value="objectGroupsDisplayValue"
                name="group[]"
            />
            <div class="col-12 col-sm-6 col-md-3">
              <accent-button
                  type="submit"
                  :dense="$isMobile"
                  label="Zoeken"
              />
            </div>
          </div>
        </form>
        <p class="text-neutral-70 q-mt-lg">
          {{ objects.total }} inrichtingselementen gevonden. Klik op het inrichtingselement voor meer
          informatie.
        </p>

        <q-list v-if="objects.data.length" separator>
          <ObjectCatalogResult :object="object"
                               v-for="object in objects.data"
                               :key="object.id"
                               :group-title="objectGroupTitle(object)" />
          <q-item v-if="objects.last_page > 1" class="flex flex-center">
            <pagination-links :items="objects" />
          </q-item>
        </q-list>

        <p v-else>
          Er zijn geen inrichtingselementen gevonden.
        </p>
      </q-card-section>
    </q-card>
  </div>
</q-page>
</template>

<script>
import PrimaryButton from '~HIOR/components/button/PrimaryButton'
import { reactive } from 'vue'
import DocumentList from '~HIOR/components/lists/DocumentList'
import ObjectCatalogResult from './ObjectCatalog/ObjectCatalogResult.vue'

export default {
  components: {
    ObjectCatalogResult,
    PrimaryButton,
    DocumentList,
  },
  props: {
    objects: {
      type: Object,
    },
    groups: {
      type: Object,
    },
    categories: {
      type: Object,
    },
    oldSearch: {
      type: Object,
    },
  },
  setup (props) {
    const search = reactive({
      query: props.oldSearch.search,
      groups: props.oldSearch.group.map(id => parseInt(id)),
      categories: props.oldSearch.category.map(id => parseInt(id)),
    })
    return {
      search,
    }
  },
  computed: {
    objectGroupsArray () {
      return this.groups.map((group) => {
        return {
          value: group.id,
          label: group.title,
        }
      })
    },
    categoriesArray () {
      return this.categories.map((category) => {
        return {
          value: category.id,
          label: category.title,
        }
      })
    },
    objectGroupsDisplayValue () {
      if (this.search.groups.length === 0 || this.search.groups.length === this.groups.length) {
        return 'Alle subcategorieën'
      }
      return `${this.search.groups.length} subcategorieën`
    },
    categoriesDisplayValue () {
      if (this.search.categories.length === 0 || this.search.categories.length === this.categories.length) {
        return 'Alle categorieën'
      }
      return `${this.search.categories.length} categorieën`
    },
  },
  methods: {
    objectGroupTitle (object) {
      const group = this.groups.filter((group) => {
        return group.id === object.object_group_id
      })

      return group.length ? group[0].title : '-'
    },
  },
}
</script>
